import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const css = ".ispui-dropdown-footer{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;padding:var(--ispui-dropdown-footer-padding, 0 20px 25px 20px);border-top:1px solid var(--ispui-dropdown-footer-border-color, transparent)}";

const ISPUIDropdownFooter = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, { class: "ispui-dropdown-footer" });
  }
  static get style() { return css; }
}, [0, "ispui-dropdown-footer"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-dropdown-footer"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-dropdown-footer":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ISPUIDropdownFooter);
      }
      break;
  } });
}

const IspuiDropdownFooter = ISPUIDropdownFooter;
const defineCustomElement = defineCustomElement$1;

export { IspuiDropdownFooter, defineCustomElement };
